import React from 'react'

export interface OpenDWContextValue {
  openDeposit: () => void
  openWithdraw: () => void
}

const defaultValue: OpenDWContextValue = {
  openDeposit: () => {},
  openWithdraw: () => {},
}

export const OpenDWContext = React.createContext<OpenDWContextValue>(defaultValue)
